import PageReservation from '@/pages/PageReservation'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageReservation,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}